
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Shield } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useEnhancedPermissions } from '@/hooks/useEnhancedPermissions';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermission?: string;
}

export function ProtectedRoute({ children, requiredPermission }: ProtectedRouteProps) {
  const { user } = useAuth();
  const { hasPermission } = useEnhancedPermissions();
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // قائمة الإيميلات المعفية من القيود
  const adminEmails = ['klidmorre@gmail.com', 'eng.khalid.work@gmail.com'];
  
  // التحقق من حالة الموافقة على الموظف وحالة الوصول
  if (user.employeeData) {
    // إعفاء المدراء من قيود الموافقة والحالة
    const isAdmin = user.employeeData.email && adminEmails.includes(user.employeeData.email);
    
    if (!isAdmin) {
      // التحقق من حالة الموافقة للمستخدمين العاديين فقط
      if (user.employeeData.approval_status !== 'approved') {
        return <Navigate to="/login" replace />;
      }
      // التحقق من حالة الوصول (يجب أن تكون 'present' للسماح بالدخول)
      if (user.employeeData.status !== 'present') {
        return <Navigate to="/login" replace />;
      }
    }
  }

  // تحقق من الصلاحيات فقط إذا كانت مطلوبة
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full p-6">
          <Alert variant="destructive">
            <Shield className="h-4 w-4" />
            <AlertDescription className="text-center">
              <div className="space-y-2">
                <h3 className="font-semibold">ليس لديك صلاحية للوصول إلى هذه الصفحة</h3>
                <p className="text-sm">الصلاحية المطلوبة: {requiredPermission}</p>
              </div>
            </AlertDescription>
          </Alert>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
